import { render, staticRenderFns } from "./TypeAheadFundSearchNew.vue?vue&type=template&id=397d43ee&"
import script from "./TypeAheadFundSearchNew.vue?vue&type=script&lang=js&"
export * from "./TypeAheadFundSearchNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports